import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';

// Default courses (fallback when API fails)
const defaultCourses = [
  {
    CourseId: 1,
    CourseName: 'CUET-UG',
    courseDesc: 'Complete preparation for CUET Undergraduate entrance',
    icon: '🎓',
    features: ['Comprehensive Study Material', 'Live Classes', 'Mock Tests'],
    studentsCount: 5000
  },
  {
    CourseId: 2,
    CourseName: 'CUET-PG',
    courseDesc: 'Preparation for CUET PG with expert guidance',
    icon: '🚀',
    features: ['Study Material', 'Previous Year Papers', 'Expert Doubt Solving'],
    studentsCount: 3500
  },
  {
    CourseId: 3,
    CourseName: 'NET/ JRF',
    courseDesc: 'Focused preparation for UGC NET and JRF exams',
    icon: '⚕️',
    features: [ 'Topic-wise Notes', 'Mock Tests', 'Doubt Clearing Sessions'],
    studentsCount: 4200
  }
];

const CoursesSection = () => {
  const [courses, setCourses] = useState(defaultCourses);
  const [loading, setLoading] = useState(false);

  // useEffect(() => {
  //   const fetchCourses = async () => {
  //     try {
  //       const response = await api.get('/courses');
  //       if (response.data.success && response.data.data.length > 0) {
  //         setCourses(response.data.data.slice(0, 3));
  //       }
  //     } catch (error) {
  //       console.log('Using default courses');
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchCourses();
  // }, []);

  return (
    <section className="py-32 bg-gradient-to-br from-primary-purple/10 to-secondary-purple/10" id="courses">
      <div className="max-w-[1400px] mx-auto px-8">
        {/* Section Header */}
        <div className="text-center mb-20">
          <h2 className="section-title">Featured Courses</h2>
          <p className="section-subtitle">
            Comprehensive programs designed for academic excellence and career success
          </p>
        </div>

        {/* Courses Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {courses.map((course, index) => (
            <div key={course.CourseId || index} className="course-card">
              <div className="course-header">
                <div className="text-5xl mb-4">{course.icon || '📚'}</div>
                <h3 className="text-2xl font-bold text-white mb-2">
                  {course.CourseName}
                </h3>
                <p className="text-text-muted text-sm">
                  {course.courseDesc || 'Expert-led preparation course'}
                </p>
              </div>
              
              <div className="p-8">
                <ul className="space-y-3 mb-8">
                  {(course.features || ['Comprehensive Study Material', 'Live Classes', 'Mock Tests']).map((feature, idx) => (
                    <li key={idx} className="text-text-light relative pl-6">
                      <span className="absolute left-0 text-accent-gold font-bold">✓</span>
                      {feature}
                    </li>
                  ))}
                </ul>
                
                {course.studentsCount && (
                  <p className="text-text-muted text-sm mb-6">
                    {course.studentsCount.toLocaleString()}+ students enrolled
                  </p>
                )}
                
                <button className="course-btn">
                  {loading ? 'Loading...' : 'Explore Course'}
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* View All Button */}
        <div className="text-center mt-12">
          <Link to="/courses" className="btn-primary">
            View All Courses
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CoursesSection;
